import React from "react";
import styles from "./TextInput.module.scss";
import { phoneMask } from "../../../../../utils/form/phoneMask";
import { dateMask } from "../../../../../utils/form/dateMask";

interface TextInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: "text" | "phone" | "email" | "date";
  multiline?: boolean;
  error?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  multiline = false,
  error,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    let newValue: string = e.target.value;

    if (type === "phone") {
      const event = e as React.ChangeEvent<HTMLInputElement>;
      const maskedValue = phoneMask(event);
      newValue = maskedValue || "";
    } else if (type === "date") {
      const event = e as React.ChangeEvent<HTMLInputElement>;
      const maskedValue = dateMask(event);
      newValue = maskedValue || "";
    }

    onChange(newValue);
  };

  const inputType = type === "email" ? "email" : type === "phone" || type === "date" ? "tel" : "text";

  return (
    <div className={styles.inputWrapper}>
      <label className={`${styles.label} ${error ? styles.error : ""}`}>{label}</label>
      {multiline ? (
        <textarea
          className={`${styles.input} ${styles.textarea} ${error ? styles.error : ""}`}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          rows={4}
        />
      ) : (
        <input
          type={inputType}
          className={`${styles.input} ${error ? styles.error : ""}`}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          inputMode={type === "phone" || type === "date" ? "numeric" : undefined}
        />
      )}
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

